import React from 'react';
import { motion } from 'framer-motion';
import BrandLogo from './BrandLogo';
import './LoadingScreen.css';

function LoadingScreen() {
  return (
    <div className="loading-screen">
      <motion.div
        className="loading-container"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
      >
        <BrandLogo className="loading-logo" />
        <span className="loading-text">Clear Horizons</span>
        <div className="loading-bubble" aria-label="Loading">
          <div className="bounce" />
          <div className="bounce" />
          <div className="bounce" />
        </div>
      </motion.div>
    </div>
  );
}

export default LoadingScreen;
